import type { FreeSpinType } from '@patrianna/shared-patrianna-types/store/SlotGameFlowModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { SlotGameFlowState } from './types'

const initialState: SlotGameFlowState = {
  activeGameCode: null,
  gameBet: null,
  freeSpins: null,
  goldMinBet: null,
  sweepstakeMinBet: null,
  lowOnCoinsLastDateOpened: null,
  freeSpinsLoaded: false,
}

export const slotGameFlowSlice = createSlice({
  name: 'slotGameFlow',
  initialState,
  reducers: {
    setActiveGameCode: (state, action: PayloadAction<{ code: string }>) => {
      state.activeGameCode = action.payload.code
    },

    saveFreeSpins: (state, action: PayloadAction<{ freeSpins: FreeSpinType[] }>) => {
      state.freeSpins = action.payload.freeSpins
    },

    setGoldMinBet: (state, action: PayloadAction<{ goldMinBet: number }>) => {
      state.goldMinBet = action.payload.goldMinBet
    },

    setSweepstakeMinBet: (state, action: PayloadAction<{ sweepstakeMinBet: number }>) => {
      state.sweepstakeMinBet = action.payload.sweepstakeMinBet
    },

    setLowOnCoinsLastDateOpened: (state, action: PayloadAction<{ lowOnCoinsLastDateOpened: number }>) => {
      state.lowOnCoinsLastDateOpened = action.payload.lowOnCoinsLastDateOpened
    },

    clearSlotGameFlow: (state) => {
      return { ...initialState, freeSpinsLoaded: state.freeSpinsLoaded }
    },

    setFreeSpinsLoaded: (state) => {
      state.freeSpinsLoaded = true
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof slotGameFlowSlice.actions>>
export const { actions } = slotGameFlowSlice
